import React from 'react';
import { FaRegTrashAlt } from 'react-icons/fa';
import { MdAdd } from 'react-icons/md';
import { Button } from 'rizzui';
import RequiredInput from '../../../components/forms/InputHOC';
import FormGroup from '../../../layout/shared/form-group';
import cn from '../../../utils/classNames';

interface Bank {
    name: string;
    iban: string;
    creditor: string;
    bic: string;
    bankIdentifier: string;
}

interface BanksFormProps {
    formik: any;
    bank: Bank;
    setBank: (bank: Bank) => void;
}

const BanksForm: React.FC<BanksFormProps> = ({ formik, bank, setBank }) => {
    return (
        <FormGroup
            title="Bancos"
            description="Datos de los bancos vinculados a la empresa"
            titleCols="@md:col-span-12"
            childCols="@md:col-span-12 gap-0"
        >
            <div className='mb-4'>
                {formik.values.banks.map((b: any, index: number) => {
                    return (
                        <div className={cn('grid md:grid-cols-12', { 'mt-4': index > 1 && formik.values.banks.length > 1 })}>
                            <div key={index} className="col-span-12 md:col-span-10 grid md:grid-cols-4 gap-4">
                                <RequiredInput
                                    id={`banks[${index}].name`}
                                    label="Nombre"
                                    formik={formik}
                                    value={b.name}
                                    error={formik.errors.banks && formik.errors.banks[index]?.name}
                                    className='@md:col-span-2'
                                />

                                <RequiredInput
                                    id={`banks[${index}].iban`}
                                    label="IBAN"
                                    formik={formik}
                                    value={b.iban}
                                    error={formik.errors.banks && formik.errors.banks[index]?.iban}
                                    className='@md:col-span-2'
                                />

                                <RequiredInput
                                    id={`banks[${index}].creditor`}
                                    label="Acreedor"
                                    formik={formik}
                                    value={b.creditor}
                                    error={formik.errors.banks && formik.errors.banks[index]?.creditor}
                                    className='@md:col-span-2'
                                />

                                <RequiredInput
                                    id={`banks[${index}].bic`}
                                    label="Código BIC"
                                    formik={formik}
                                    value={b.bic}
                                    error={formik.errors.banks && formik.errors.banks[index]?.bic}
                                    className='@md:col-span-1'
                                />

                                <RequiredInput
                                    id={`banks[${index}].bankIdentifier`}
                                    label="Id. Bancario"
                                    formik={formik}
                                    value={b.bankIdentifier}
                                    error={formik.errors.banks && formik.errors.banks[index]?.bankIdentifier}
                                    className='@md:col-span-1'
                                />
                            </div>

                            <div className="col-span-12 md:col-span-2 flex justify-center md:justify-end items-center mt-4 md:mt-0">
                                <Button
                                    type="button"
                                    color="danger"
                                    size='sm'
                                    onClick={() => {
                                        const updatedData = formik.values.banks.filter((b: any, i: number) => i !== index);
                                        formik.setFieldValue('banks', updatedData);
                                    }}
                                >
                                    <FaRegTrashAlt />
                                </Button>
                            </div>

                            <hr className="border-gray-400 mt-8 border-dotted col-span-12" />
                        </div>
                    )
                })}
            </div>

            <div className={cn("grid md:grid-cols-12 mb-4", { 'mt-4': formik.values.banks.length > 0 })}>
                <div className='md:col-span-10 grid md:grid-cols-4 gap-4'>
                    <RequiredInput
                        id='bank_name'
                        label="Nombre"
                        formik={formik}
                        onChange={(e: any) => setBank({ ...bank, name: e.target.value })}
                        value={bank.name}
                        className='@md:col-span-2'
                    />

                    <RequiredInput
                        id='bank_iban'
                        label="IBAN"
                        formik={formik}
                        onChange={(e: any) => setBank({ ...bank, iban: e.target.value })}
                        value={bank.iban}
                        className='@md:col-span-2'
                    />

                    <RequiredInput
                        id='bank_creditor'
                        label="Acreedor"
                        formik={formik}
                        onChange={(e: any) => setBank({ ...bank, creditor: e.target.value })}
                        value={bank.creditor}
                        className='@md:col-span-2'
                    />

                    <RequiredInput
                        id='bank_bic'
                        label="Código BIC"
                        formik={formik}
                        onChange={(e: any) => setBank({ ...bank, bic: e.target.value })}
                        value={bank.bic}
                        className='@md:col-span-1'
                    />

                    <RequiredInput
                        id='bank_bankIdentifier'
                        label="Id. Bancario"
                        formik={formik}
                        onChange={(e: any) => setBank({ ...bank, bankIdentifier: e.target.value })}
                        value={bank.bankIdentifier}
                        className='@md:col-span-1'
                    />
                </div>

                <div className="md:col-span-2 flex justify-center md:justify-end items-center mt-4 md:mt-0">
                    <Button
                        type="button"
                        color='secondary'
                        size='sm'
                        disabled={!bank.name || !bank.iban || !bank.creditor || !bank.bic || !bank.bankIdentifier}
                        onClick={() => {
                            formik.setFieldValue('banks', [...formik.values.banks, bank]);
                            setBank({ name: '', iban: '', creditor: '', bic: '', bankIdentifier: '' });
                        }}
                        className='px-2'
                    >
                        <MdAdd className='h-4 w-4' />
                    </Button>
                </div>
            </div>
        </FormGroup>
    );
};

export default BanksForm;